<div class="row">
    <a routerLink="../add" class="btn-add" *ngIf="accessMP">
        <i class="fa fa-plus px-2"></i> Agregar
    </a>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Temática</th>
                    <th scope="col">Nombre largo</th>
                    <th scope="col">Año</th>
                    <th scope="col">Color</th>
                    <th scope="col">Estado</th>
                    <th scope="col" style="min-width: 40px;"></th>
                    <th scope="col" style="min-width: 40px;"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let obj of t2; let i = index">
                    <td>{{ obj.id }}</td>
                    <td>{{ obj.title }}</td>
                    <td>{{ obj.summary }}</td>
                    <td>{{ obj.year }}</td>
                    <td class="text-center"><i class="fa fa-square" [style.color]="obj.color"></i></td>
                    <td>
                        <div class="label-active text-center" *ngIf="obj.status">ACTIVO</div>
                        <div class="label-inactive text-center" *ngIf="!obj.status">INACTIVO</div>
                    </td>
                    <td class=" text-center"><a class="a-icon text-center"
                            [routerLink]="['/adm/tendencia/tematica/edit', obj.id]"><i
                                class="fa fa-pencil i-icon"></i></a></td>
                    <td class=" text-center"><a class="a-icon text-center" routerLink=""><i
                                class="fa fa-trash i-icon"></i></a></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>